import { SET_PLACES } from './../actions/dataForState/dataForProfile/setPlacesToState';
import { SET_HITOS } from './../actions/dataForState/dataForProfile/setHitosToState';
import { SET_CITIES } from './../actions/dataForState/dataForProfile/setCitiesToState';
import { SET_COUNTRIES } from './../actions/dataForState/dataForProfile/setCountriesToState';
import { SET_NEIGHBORHOODS } from './../actions/dataForState/dataForProfile/setNeighborhoodsToState';
import { SET_PROVINCES } from './../actions/dataForState/dataForProfile/setProvincesToState';
import { SET_STYLES } from './../actions/dataForState/dataForProfile/setStylesToState';
import { SET_TYPES } from './../actions/dataForState/dataForProfile/setTypesToState';
import { SET_SERVICES } from './../actions/dataForState/dataForProfile/setServicesToState';

export const places = (state = {}, action) => {
    switch(action.type) {
        case SET_PLACES: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const hitos = (state = {}, action) => {
    switch(action.type) {
        case SET_HITOS: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const cities = (state = {}, action) => {
    switch(action.type) {
        case SET_CITIES: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const countries = (state = {}, action) => {
    switch(action.type) {
        case SET_COUNTRIES: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const neighborhoods = (state = {}, action) => {
    switch(action.type) {
        case SET_NEIGHBORHOODS: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const provinces = (state = {}, action) => {
    switch(action.type) {
        case SET_PROVINCES: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const styles = (state = {}, action) => {
    switch(action.type) {
        case SET_STYLES: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const types = (state = {}, action) => {
    switch(action.type) {
        case SET_TYPES: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const services = (state = {}, action) => {
    switch(action.type) {
        case SET_SERVICES: {
            return action.payload;
        }
        default:
            return state;
    }
}